var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_61_86",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 30,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 1H1V33H31V1Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_61_86)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_61_86",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 30,
    height: 32
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 1H1V33H31V1Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_61_86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0645 3.14255C13.3011 2.55784 13.7069 2.05711 14.2299 1.70452C14.7529 1.35194 15.3692 1.16357 16 1.16357C16.6307 1.16357 17.2471 1.35194 17.7701 1.70452C18.2931 2.05711 18.6989 2.55784 18.9355 3.14255C21.2769 3.78646 23.3421 5.18118 24.814 7.1125C26.286 9.04381 27.0832 11.4049 27.0833 13.8332V21.2702L29.984 25.6212C30.1431 25.8596 30.2345 26.1368 30.2484 26.4231C30.2623 26.7094 30.1982 26.9941 30.063 27.2469C29.9277 27.4996 29.7264 27.7109 29.4805 27.8582C29.2346 28.0055 28.9533 28.0833 28.6667 28.0832H21.4862C21.2956 29.4023 20.6361 30.6086 19.6285 31.481C18.6209 32.3534 17.3328 32.8336 16 32.8336C14.6672 32.8336 13.379 32.3534 12.3715 31.481C11.3639 30.6086 10.7044 29.4023 10.5137 28.0832H3.33333C3.04668 28.0833 2.76539 28.0055 2.51948 27.8582C2.27357 27.7109 2.07226 27.4996 1.93703 27.2469C1.80179 26.9941 1.73771 26.7094 1.75162 26.4231C1.76553 26.1368 1.8569 25.8596 2.01599 25.6212L4.91666 21.2702V13.8332C4.91666 8.72855 8.36833 4.42822 13.0645 3.14255ZM13.7612 28.0832C13.9247 28.5466 14.2279 28.9478 14.629 29.2316C15.0301 29.5154 15.5094 29.6679 16.0008 29.6679C16.4922 29.6679 16.9714 29.5154 17.3725 29.2316C17.7737 28.9478 18.0769 28.5466 18.2404 28.0832H13.7612ZM16 5.91655C13.9004 5.91655 11.8867 6.75062 10.4021 8.23529C8.9174 9.71995 8.08333 11.7336 8.08333 13.8332V21.7499C8.0834 22.0627 7.99084 22.3684 7.81733 22.6287L6.29258 24.9166H25.7058L24.1811 22.6287C24.0081 22.3683 23.9161 22.0625 23.9167 21.7499V13.8332C23.9167 11.7336 23.0826 9.71995 21.5979 8.23529C20.1133 6.75062 18.0996 5.91655 16 5.91655Z",
    fill: "#FF573B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.8016dce4e392093b43e04f03f87e7182.svg";
export { ForwardRef as ReactComponent };